// A ZCP-pool signup (native `?zcp=true`, or `zcp: true` inside the OAuth state)
// assigns the user to a precreated company whose project already contains a
// ZCP. The assignment is done server-side; the frontend only needs to (a) know
// a claim is in flight and (b) jump to the ZCP once fully authed. A cookie is
// the carrier because it survives both the OAuth full-page redirect
// (GitHub/GitLab) and the post-signup navigation that wipe the in-memory
// store — mirroring the existing `reference` cookie.

export const ZCP_POOL_CLAIM_COOKIE = 'claimZcpPool';

// 10 minutes: comfortably covers the OAuth provider round-trip while still
// self-expiring if the drain never fires (e.g. the tab is abandoned mid-signup).
const ZCP_POOL_CLAIM_COOKIE_MAX_AGE = 600;

export const setZcpPoolClaimCookie = (): void => {
  if (typeof document === 'undefined') { return; }
  document.cookie =
    `${ZCP_POOL_CLAIM_COOKIE}=1; path=/; max-age=${ZCP_POOL_CLAIM_COOKIE_MAX_AGE}; SameSite=Strict`;
};

export const hasPendingZcpPoolClaim = (): boolean => {
  if (typeof document === 'undefined') { return false; }
  return document.cookie
    .split('; ')
    .some((row) => row.startsWith(`${ZCP_POOL_CLAIM_COOKIE}=`));
};

export const clearZcpPoolClaimCookie = (): void => {
  if (typeof document === 'undefined') { return; }
  document.cookie = `${ZCP_POOL_CLAIM_COOKIE}=; path=/; max-age=0; SameSite=Strict`;
};
